var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.7,
    height: 21.7,
    viewBox: "0 0 22.7 21.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar",
    transform: "translate(-0.15 -0.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2732",
    "data-name": "Group 2732",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_8",
    "data-name": "Line 8",
    d: "M21,.85H0V-.85H21Z",
    transform: "translate(0 7.101)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1016",
    "data-name": "Rectangle 1016",
    d: "M3-.85H18A3.854,3.854,0,0,1,21.85,3V15A3.854,3.854,0,0,1,18,18.85H3A3.854,3.854,0,0,1-.85,15V3A3.854,3.854,0,0,1,3-.85Zm15,18A2.152,2.152,0,0,0,20.15,15V3A2.152,2.152,0,0,0,18,.85H3A2.152,2.152,0,0,0,.85,3V15A2.152,2.152,0,0,0,3,17.15Z",
    transform: "translate(0 2.101)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2071",
    "data-name": "Path 2071",
    d: "M0,4.85A.85.85,0,0,1-.85,4V0A.85.85,0,0,1,0-.85.85.85,0,0,1,.85,0V4A.85.85,0,0,1,0,4.85Z",
    transform: "translate(5 0.101)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_10",
    "data-name": "Line 10",
    d: "M0,4.85A.85.85,0,0,1-.85,4V0A.85.85,0,0,1,0-.85.85.85,0,0,1,.85,0V4A.85.85,0,0,1,0,4.85Z",
    transform: "translate(16 0.101)",
    fill: "#212121"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.1f3f1430529b2970d93ad6c1a4f41650.svg";
export { ForwardRef as ReactComponent };